import { z } from 'zod';
import { RecommendedSupportStatus } from '../../../enums';
import { requiredString } from '../../../../validation';

export const InitialAssessmentSummaryDataReferredProfessionalSchema = z.object({
  // Whther referred in PCP
  referredEarlier: z.boolean().optional(),

  service: z.object(
    {
      id: z.string().min(1),
      name: z.string().min(1),
      professionalType: z.string().optional(),
    },
    'Support type is required',
  ),

  concern: requiredString('Concern is required'),

  appointmentId: z.string().optional(),

  professional: z
    .object({
      id: z.string().optional(),
      name: z.string().optional(),
    })
    .optional(),

  status: z.enum(RecommendedSupportStatus),
});

export type InitialAssessmentSummaryDataReferredProfessional = z.infer<
  typeof InitialAssessmentSummaryDataReferredProfessionalSchema
>;
